import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import "./scheduleDashboardTour.css";

function isDesktopLayout() {
  if (typeof window === "undefined" || !window.matchMedia) return true;
  return window.matchMedia("(min-width: 769px)").matches;
}

/**
 * Tour cho /elearning/calendar (ScheduleDashboard).
 * Các bước gắn [data-tour] trên header, thanh điều hướng, ScheduleFilter và vùng lịch.
 */
export function startScheduleDashboardTour() {
  const lg = isDesktopLayout();

  const steps = [
    {
      popover: {
        title: "Hướng dẫn nhanh",
        description:
          "Giới thiệu vài vùng chính của Thời khóa biểu: lọc theo cơ sở/môn/khóa, xem theo tuần hoặc tháng, và xem chi tiết buổi dạy. Bấm Tiếp để xem từng bước.",
        side: "over",
        align: "center",
      },
    },
  ];

  const segments = [
    {
      selector: '[data-tour="schedule-header"]',
      title: "Tiêu đề & ngữ cảnh",
      description:
        "Đây là màn theo dõi lịch báo giảng / lớp học theo bộ lọc bạn chọn phía dưới.",
      side: "bottom",
    },
    {
      selector: '[data-tour="schedule-top-nav"]',
      title: lg ? "Chế độ xem & thời gian" : "Chọn ngày nhanh",
      description: lg
        ? "Chuyển giữa Tháng / Tuần / Ngày; dùng mũi tên hoặc bấm vào dòng ngày để mở lịch; HÔM NAY để về ngày hiện tại."
        : "Trên điện thoại, lịch dạng danh sách theo ngày: dùng mũi tên, chọn ngày trên dòng chữ, hoặc HÔM NAY.",
      side: "bottom",
    },
    {
      selector: '[data-tour="schedule-filter-bar"]',
      title: "Lọc & tìm kiếm",
      description:
        "Chọn địa điểm lớp (trung tâm / tại trường / tất cả), tìm theo lớp–giáo viên–phòng, làm mới dữ liệu, và mở Lọc nâng cao để chọn chi nhánh, môn, khóa học. Ở chế độ Tháng trên máy tính có thể xuất PDF.",
      side: "bottom",
    },
    {
      selector: '[data-tour="schedule-content-area"]',
      title: "Khung lịch",
      description:
        "Danh sách buổi học theo ngày (mobile hoặc chế độ Ngày), hoặc lưới tuần / lịch tháng trên màn hình lớn. Bấm một ô để xem chi tiết buổi dạy.",
      side: "top",
    },
  ];

  for (const seg of segments) {
    const el = document.querySelector(seg.selector);
    if (el) {
      steps.push({
        element: el,
        popover: {
          title: seg.title,
          description: seg.description,
          side: seg.side,
        },
      });
    }
  }

  if (steps.length <= 1) {
    window.alert(
      "Chưa tải được các vùng giao diện để hướng dẫn. Hãy tải lại trang và thử lại."
    );
    return;
  }

  const d = driver({
    showProgress: true,
    smoothScroll: true,
    stagePadding: 10,
    stageRadius: 14,
    overlayOpacity: 0.68,
    overlayColor: "#0f172a",
    popoverClass: "schedule-dashboard-tour-popover",
    onPopoverRender: (popover) => {
      popover.wrapper?.setAttribute?.("lang", "vi");
    },
    nextBtnText: "Tiếp",
    prevBtnText: "Trước",
    doneBtnText: "Xong",
    progressText: "Bước {{current}} / {{total}}",
    showButtons: ["next", "previous", "close"],
    steps,
  });

  d.drive();
}
